export default __webpack_public_path__ + "static/media/WaterPump.44544c14.svg";